import React from 'react';
import './style.css';
import {Divider} from 'antd';
import {Link} from 'react-router-dom';
import useLocalization from '../../../Localization';

const ProfileInfo = ({logout}) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const {ApplicationString} = useLocalization();
  const userLogout = () => {
    logout();
  };
  const currentPath = window.location.pathname;

  switch (true) {
    case userInfo && userInfo.role === 'admin':
    case userInfo && userInfo.role === 'super_admin':
    case userInfo && userInfo.role === 'event_manager_admin':
    case userInfo && userInfo.role === 'event_registration_admin':
      return (
        <div className='main-profile-container'>
          <div className='profile-view-container'>
            <label>{ApplicationString['profileViewComponent.heading']}</label>
            <div className='profile-user-wapper'>
              <span>{userInfo?.first_name?.slice(0, 1)}</span>
              <div className='profile-email-text'>
                <p>{userInfo?.first_name}</p>
                <label>{userInfo?.email}</label>
              </div>
            </div>
          </div>
          <Link to='/admin/events'>
            <li>{ApplicationString['profileViewComponent.subheading']}</li>
          </Link>

          {userInfo?.first_name ? (
            <>
              <Link to='/updateProfile'>
                <li>
                  {
                    ApplicationString[
                      'profileViewComponent.button.updateProfile'
                    ]
                  }
                </li>
              </Link>
              <Link to='/changePassword'>
                <li>
                  {
                    ApplicationString[
                      'profileViewComponent.button.changePassword'
                    ]
                  }
                </li>
              </Link>
              <Divider prefixCls='profile-divider' />
              <Link to='/jobs'>
                <li>
                  {
                    ApplicationString[
                      'profileViewComponent.button.createJobPosting'
                    ]
                  }
                </li>
              </Link>
              <Link to='/ads'>
                <li>
                  {ApplicationString['profileViewComponent.button.createAd']}
                </li>
              </Link>
              <Link to='/myCart'>
                <li>
                  {ApplicationString['profileViewComponent.button.myCart']}
                </li>
              </Link>
              <Link to='/myEvents'>
                <li>
                  {ApplicationString['profileViewComponent.button.myEvents']}
                </li>
              </Link>
              <Divider prefixCls='profile-divider' />
            </>
          ) : null}
          <button
            className='common-button-header bg-remove extend-button-w extend-settings-button'
            onClick={userLogout}>
            {ApplicationString['profileViewComponent.button.logout']}
          </button>
        </div>
      );

    case userInfo && userInfo.role === 'user':
      return (
        <div className='main-profile-container'>
          <div className='profile-view-container'>
            <label>{ApplicationString['profileViewComponent.heading']}</label>
            <div className='profile-user-wapper'>
              <span>{userInfo?.first_name?.slice(0, 1)}</span>
              <div className='profile-email-text'>
                <p>{userInfo?.first_name}</p>
                <label>{userInfo?.email}</label>
              </div>
            </div>
          </div>
          <Link to='/updateProfile'>
            <li>
              {ApplicationString['profileViewComponent.button.updateProfile']}
            </li>
          </Link>
          <Link to='/changePassword'>
            <li>
              {ApplicationString['profileViewComponent.button.changePassword']}
            </li>
          </Link>
          <Divider prefixCls='profile-divider' />
          <Link to='/jobs'>
            <li>
              {
                ApplicationString[
                  'profileViewComponent.button.createJobPosting'
                ]
              }
            </li>
          </Link>
          <Link to='/ads'>
            <li>{ApplicationString['profileViewComponent.button.createAd']}</li>
          </Link>
          <Link to='/myCart'>
            <li>{ApplicationString['profileViewComponent.button.myCart']}</li>
          </Link>
          <Link to='/myEvents'>
            <li>{ApplicationString['profileViewComponent.button.myEvents']}</li>
          </Link>
          <Divider prefixCls='profile-divider' />
          <button
            className='common-button-header bg-remove extend-button-w extend-settings-button'
            onClick={userLogout}>
            {ApplicationString['profileViewComponent.button.logout']}
          </button>
        </div>
      );

    case currentPath === '/login':
      return (
        <div className='main-profile-container'>
          <Link to='/register'>
            <button className='common-button-header bg-remove extend-button-w extend-settings-button'>
              {ApplicationString['profileViewComponent.button.joinPbss']}
            </button>
          </Link>
        </div>
      );

    case currentPath === '/register':
      return (
        <div className='main-profile-container'>
          <Link to='/login'>
            <button className='common-button-header extend-settings-button'>
              {ApplicationString['profileViewComponent.button.login']}
            </button>
          </Link>
        </div>
      );

    default:
      return (
        <div className='main-profile-container'>
          {currentPath !== '/login' && (
            <Link to='/login'>
              <button className='common-button-header extend-settings-button'>
                {ApplicationString['profileViewComponent.button.login']}
              </button>
            </Link>
          )}
          {currentPath !== '/register' && (
            <Link to='/register'>
              <button className='common-button-header bg-remove extend-button-w extend-settings-button'>
                {ApplicationString['profileViewComponent.button.joinPbss']}
              </button>
            </Link>
          )}
        </div>
      );
  }
};

export default ProfileInfo;
